import { createAppStore } from '@app/core/stores';
import { getInitialThemeMode, ThemeMode } from '../theme-mode';

interface UiState {
  sidenavOpen: boolean;
  /** Timestamp when the full version alert was last shown (for 24h cooldown). */
  versionCheckLastAlertShownAt: number | null;
  /** User-selected light/dark theme preference. */
  themeMode: ThemeMode;
  // Actions
  toggleSidenav: (open?: boolean) => void;
  /** Records that the full version alert was shown; used for 24h cooldown. */
  markVersionAlertShown: () => void;
  setThemeMode: (mode: ThemeMode) => void;
  toggleThemeMode: () => void;
}

/**
 * Zustand store for managing UI state.
 * Replaces the Redux implementation with a simpler Zustand store.
 */
export const useUiStore = createAppStore<UiState>('UiStore', {
  persist: { name: 'app.ui', version: 3, purgeOnLogout: false },
})((set) => ({
  // Initial state
  sidenavOpen: true,
  versionCheckLastAlertShownAt: null,
  themeMode: getInitialThemeMode(),

  // Toggle sidenav - if boolean provided, set to that value, otherwise toggle
  toggleSidenav: (open) => {
    set((state) => ({
      sidenavOpen: open !== undefined ? open : !state.sidenavOpen,
    }));
  },

  markVersionAlertShown: () => {
    set({ versionCheckLastAlertShownAt: Date.now() });
  },

  setThemeMode: (mode) => {
    set({ themeMode: mode });
  },

  toggleThemeMode: () => {
    set((state) => ({
      themeMode: state.themeMode === 'dark' ? 'light' : 'dark',
    }));
  },
}));
